import { useMemo } from 'react';
import './style.css';

const buildPath = (i, mirror) => {
  const offset = i * 6;
  const x = mirror ? -1 : 1;
  return `M${-380 * x} ${489 - offset}C${-380 * x} ${489 - offset} ${
    -312 * x
  } ${316 - offset} ${152 * x} ${256 - offset}C${616 * x} ${196 - offset} ${
    684 * x
  } ${64 - offset} ${684 * x} ${64 - offset}`;
};

export default function BackgroundPaths({
  className = '',
  count = 24,
  strokeColor = '18, 118, 160',
}) {
  const paths = useMemo(() => {
    const list = [];
    for (let i = 0; i < count; i++) {
      
      list.push({
        id: `p-${i}`,
        d: buildPath(i, false),
        width: 0.5 + i * 0.03,
        opacity: 0.08 + i * 0.02,
        delay: (i / count) * 6,
      });
      
      list.push({
        id: `q-${i}`,
        d: buildPath(i, true),
        width: 0.5 + i * 0.03,
        opacity: 0.08 + i * 0.02,
        delay: (i / count) * 6 + 0.5,
      });

    }
    return list;
  }, [count]);

  return (
    <div className={`background-paths ${className}`} aria-hidden="true">
      <svg
        className="background-paths-svg"
        viewBox="0 0 696 316"
        fill="none"
        preserveAspectRatio="xMidYMid slice"
      >
        {paths.map((p) => (
          <path
            key={p.id}
            d={p.d}
            stroke={`rgba(${strokeColor}, ${p.opacity})`}
            strokeWidth={p.width}
            className="background-paths-line"
            style={{ animationDelay: `${p.delay}s` }}
          />
        ))}
      </svg>
    </div>
  );
}
